import { FIND_SPOT_REQUEST, findSpotSuccess, findSpotFailure} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const findSpotEpic:TEpic = (action$, store$, { SpotRepository }) => {
    return action$.pipe(
        ofType(FIND_SPOT_REQUEST),
        mergeMap( action =>{
            const { id } = action.payload;

            if(!id.trim()) {
                return EMPTY;
            }

            return from(
                SpotRepository.findById( id )
                    .then(spot => findSpotSuccess(spot))
                    .catch(error => findSpotFailure(error)),
            );
        }),
    );
}
